import { ApplicationStatus } from '@/CandidateExperience/constants/applicationStatus'

export const getApplicationStatusExplanation = ({ companyName, applicationStatus }) => {
  const applicationStatusExplanation = {
    [ApplicationStatus.Expired]: 'Pending applications are expired if the company doesn’t respond within 14 days.',
    [ApplicationStatus.PositionClosed]: `${companyName} has closed this job.`,
    [ApplicationStatus.CandidatePlaced]: 'Pending applications are withdrawn when you are hired.',
  }

  return applicationStatusExplanation[applicationStatus]
}
